// ============================================================
// shared/src/event-types.ts
// ★ R12：内部规范化事件类型；ORDER_UNDER_FAIL↔ORDER_FAIL 双向转换
// ============================================================

/** 内部规范化事件类型 */
export enum EventType {
  INSURE            = 'INSURE',
  ORDER_UNDER_FAIL  = 'ORDER_UNDER_FAIL',
  SURRENDER         = 'SURRENDER',
  RENEWAL           = 'RENEWAL',
  TERMINATE         = 'TERMINATE',
}

/** 京东查询接口出站时使用的事件类型（ORDER_UNDER_FAIL → ORDER_FAIL） */
export enum JdOutboundEventType {
  INSURE     = 'INSURE',
  ORDER_FAIL = 'ORDER_FAIL',
  SURRENDER  = 'SURRENDER',
  RENEWAL    = 'RENEWAL',
  TERMINATE  = 'TERMINATE',
}

/** 事件类型值列表（用于校验和检查） */
export const EVENT_TYPE_VALUES: EventType[] = Object.values(EventType);

/** 获取京东出站事件类型：ORDER_UNDER_FAIL → ORDER_FAIL */
export function toJdOutboundEventType(eventType: EventType): JdOutboundEventType {
  if (eventType === EventType.ORDER_UNDER_FAIL) return JdOutboundEventType.ORDER_FAIL;
  return eventType as unknown as JdOutboundEventType;
}

/** 京东入站事件类型归一：ORDER_FAIL → ORDER_UNDER_FAIL */
export function normalizeEventType(raw: string): EventType {
  const upper = raw.toUpperCase().trim();
  if (upper === 'ORDER_FAIL' || upper === 'ORDER_UNDER_FAIL') return EventType.ORDER_UNDER_FAIL;
  if (upper === 'INSURE') return EventType.INSURE;
  if (upper === 'SURRENDER') return EventType.SURRENDER;
  if (upper === 'RENEWAL') return EventType.RENEWAL;
  if (upper === 'TERMINATE') return EventType.TERMINATE;
  throw new Error(`Unknown event type: ${raw}`);
}
